import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const YouthFounderAcceleration = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("startup");
  const [counter, setCounter] = useState({
    founders: 0,
    startups: 0,
    mentors: 0,
    funding: 0,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((prev) => ({
        founders: prev.founders < 250000 ? prev.founders + 2500 : 250000,
        startups: prev.startups < 50000 ? prev.startups + 500 : 50000,
        mentors: prev.mentors < 5000 ? prev.mentors + 50 : 5000,
        funding: prev.funding < 100 ? prev.funding + 1 : 100,
      }));
    }, 25);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-slate-950 via-indigo-950 to-slate-950 text-white">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-16 left-10 w-72 h-72 rounded-full bg-violet-600/20 blur-3xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-80 h-80 rounded-full bg-pink-600/20 blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 w-64 h-64 rounded-full bg-cyan-500/10 blur-3xl -translate-x-1/2 -translate-y-1/2"></div>

        {[...Array(25)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-white/10 animate-pulse"
            style={{
              width: `${2 + Math.random() * 5}px`,
              height: `${2 + Math.random() * 5}px`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
            }}
          />
        ))}
      </div>

      <section className="relative z-10 max-w-7xl mx-auto px-4 pt-14 pb-4">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-pink-400/30 bg-pink-500/10 px-3 py-1 text-[11px] font-semibold text-pink-200 backdrop-blur-md">
              🚀 Think5Whys FoundHer
            </div>

            <h1 className="mt-3 text-3xl sm:text-5xl font-black leading-tight">
              Youth Founder
              <br />
              <span className="bg-gradient-to-r from-pink-400 via-violet-300 to-cyan-300 bg-clip-text text-transparent">
                Acceleration
              </span>
            </h1>

            <p className="mt-3 max-w-xl text-sm sm:text-base leading-7 text-slate-100">
              Helping ambitious youth transform ideas into scalable startups
              through mentorship, validation, funding readiness, business tools,
              AI guidance and a powerful founder community.
            </p>

            <div className="mt-4 flex flex-wrap gap-3">
              <button
                onClick={() => navigate("")}
                className="rounded-xl bg-gradient-to-r from-pink-600 to-violet-600 px-2 py-1 text-xs sm:text-sm font-bold shadow-lg transition hover:scale-105"
              >
                1️⃣ Join Accelerator as Digital Director
              </button>

              <button
                onClick={() => navigate("")}
                className="rounded-xl border border-white/20 bg-white/10 px-2 py-1 text-xs sm:text-sm font-semibold backdrop-blur-md transition hover:bg-white/20"
              >
                2️⃣ Assess Your Entrepreneurial SWOT
              </button>

              <button
                onClick={() => navigate("")}
                className="rounded-xl border border-white/20 bg-white/10 px-2 py-1 text-xs sm:text-sm font-semibold backdrop-blur-md transition hover:bg-white/20"
              >
                3️⃣ Get Essential Life-Defining Orientation from the Mentor Team
              </button>

              <button
                onClick={() => navigate("")}
                className="rounded-xl border border-white/20 bg-white/10 px-2 py-1 text-xs sm:text-sm font-semibold backdrop-blur-md transition hover:bg-white/20"
              >
                4️⃣ Launch Your Startup with Think5Whys Tech Ecosystem Free*
              </button>

              <button
                onClick={() => navigate("")}
                className="rounded-xl border border-cyan-400/30 bg-cyan-500/10 px-2 py-1 text-xs sm:text-sm font-semibold text-cyan-200 transition hover:bg-cyan-500/20"
              >
                5️⃣ Build Your Startup from L0 to L3
              </button>

              <button
                onClick={() => navigate("")}
                className="rounded-xl border border-emerald-400/30 bg-emerald-500/10 px-2 py-1 text-xs sm:text-sm font-semibold text-emerald-200 transition hover:bg-emerald-500/20"
              >
                📦 Access Startup Bundle
              </button>

              <button
                onClick={() => navigate("")}
                className="rounded-xl border border-amber-400/30 bg-amber-500/10 px-2 py-1 text-xs sm:text-sm font-semibold text-amber-200 transition hover:bg-amber-500/20"
              >
                🌐 Utilize Think5Whys Ecosystem as Subscriber
              </button>

              <button
                onClick={() => navigate("")}
                className="rounded-xl border border-pink-400/30 bg-pink-500/10 px-2 py-1 text-xs sm:text-sm font-semibold text-pink-200 transition hover:bg-pink-500/20"
              >
                🤝 Invite Other Youth to Earn Their Own Bread & Butter
              </button>
            </div>

            <div className="mt-4 flex flex-wrap gap-2">
              {[
                "🚀 Founder Journey",
                "👩🏻‍💼 Digital Director",
                "🧠 Entrepreneurial SWOT",
                "🎯 Mentor Orientation",
                "💼 Startup Launch",
                "📦 Startup Bundle",
                "🤖 AI Co-Founder",
                "🏪 HerKart Store",
                "📺 FiLTV",
                "🆔 PehchaanSetu",
                "🌐 Think5Whys Ecosystem",
                "📈 L0 → L3 Growth",
                "💰 Revenue First",
                "🤝 Build Your Team",
                "👭 Women-Led Startups",
                "🎓 Student Entrepreneurs",
                "💡 Problem Solver",
                "🏆 Job Creator",
                "🌍 Global Opportunities",
                "🔥 Learn • Build • Earn",
                "❤️ Made for Youth",
                "🇮🇳 Build in India",
                "⚡ Launch Faster",
                "📱 Digital Business",
            ].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-[11px] text-slate-100 backdrop-blur-md"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <div className="rounded-3xl border border-white/10 bg-white/10 backdrop-blur-xl p-6 shadow-2xl">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs uppercase tracking-widest text-pink-300">
                    FoundHer Mission
                  </p>

                  <h3 className="text-cyan-200 mt-2 text-xl font-bold">
                    Build India's Next
                    <br />
                    Generation of Women Founders
                  </h3>
                </div>

                <div className="text-5xl">👩‍💻</div>
              </div>

              <div className="mt-4 grid grid-cols-2 gap-2">
                <div className="rounded-2xl bg-white/10 p-2">
                  <div className="text-2xl font-black text-pink-300">
                    {counter.founders.toLocaleString()}+
                  </div>

                  <div className="mt-1 text-xs text-slate-100">
                    Target Founders
                  </div>
                </div>

                <div className="rounded-2xl bg-white/10 p-2">
                  <div className="text-2xl font-black text-cyan-300">
                    {counter.startups.toLocaleString()}+
                  </div>

                  <div className="mt-1 text-xs text-slate-100">Startups</div>
                </div>

                <div className="rounded-2xl bg-white/10 p-2">
                  <div className="text-2xl font-black text-violet-300">
                    {counter.mentors.toLocaleString()}+
                  </div>

                  <div className="mt-1 text-xs text-slate-100">Mentors</div>
                </div>

                <div className="rounded-2xl bg-white/10 p-2">
                  <div className="text-2xl font-black text-emerald-300">
                    ₹{counter.funding}Cr+
                  </div>

                  <div className="mt-1 text-xs text-slate-100">
                    Funding Goal
                  </div>
                </div>
              </div>

              <div className="mt-4 rounded-2xl border border-emerald-500/20 bg-emerald-500/10 p-2">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs text-emerald-300">Current Focus</p>

                    <h4 className="text-purple-300 font-bold mt-1">
                      Validate → Build → Launch → Scale
                    </h4>
                  </div>

                  <div className="text-3xl">🌱</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* STATS STRIP */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 pb-4">
        <div className="max-w-7xl mx-auto rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl">
          <div className="grid grid-cols-2 md:grid-cols-4">
            {[
              ["🚀", "Idea Validation", "100+"],
              ["💰", "Funding Connect", "50+"],
              ["🤝", "Mentorship", "5000+"],
              ["🌍", "Global Network", "25 Countries"],
            ].map((item) => (
              <div
                key={item[1]}
                className="border-b md:border-b-0 md:border-r last:border-r-0 border-white/10 p-5 text-center"
              >
                <div className="text-3xl">{item[0]}</div>

                <div className="mt-2 text-xl font-black">{item[2]}</div>

                <div className="mt-1 text-xs text-slate-200">{item[1]}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* ====================================================== */}
      {/* STARTUP JOURNEY */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-3">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <span className="inline-flex rounded-full border border-cyan-400/20 bg-cyan-500/10 px-3 py-1 text-[11px] font-semibold text-cyan-200">
              🚀 Founder Journey
            </span>

            <h2 className="text-yellow-100 mt-2 text-2xl sm:text-4xl font-black">
              From Idea to Investment
            </h2>

            <p className="mt-2 max-w-2xl mx-auto text-sm text-slate-200">
              Every founder follows a structured acceleration roadmap designed
              to reduce risk, improve execution and increase startup success.
            </p>
          </div>

          <div className="mt-5 grid lg:grid-cols-5 gap-2">
            {[
              {
                icon: "💡",
                title: "Discover",
                desc: "Identify real problems worth solving.",
              },
              {
                icon: "📝",
                title: "Validate",
                desc: "Interview customers and validate demand.",
              },
              {
                icon: "🛠️",
                title: "Build MVP",
                desc: "Launch your first product quickly.",
              },
              {
                icon: "📈",
                title: "Grow",
                desc: "Acquire users and refine your model.",
              },
              {
                icon: "💰",
                title: "Scale",
                desc: "Funding, expansion and long-term growth.",
              },
            ].map((step, index) => (
              <div
                key={step.title}
                className="relative rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-5 hover:bg-white/10 transition-all duration-300"
              >
                <div className="absolute -top-3 left-4 w-8 h-8 rounded-full bg-gradient-to-r from-pink-600 to-violet-600 flex items-center justify-center text-xs font-bold">
                  {index + 1}
                </div>

                <div className="text-4xl mt-2">{step.icon}</div>

                <h3 className="text-cyan-200 mt-2 font-bold text-lg">{step.title}</h3>

                <p className="mt-2 text-xs leading-6 text-slate-200">
                  {step.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* ACCELERATION TRACKS */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-2">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            <button
              onClick={() => setActiveTab("startup")}
              className={`rounded-full px-4 py-2 text-xs font-semibold transition ${
                activeTab === "startup"
                  ? "bg-pink-600"
                  : "bg-white/10 hover:bg-white/20"
              }`}
            >
              🚀 Startup Track
            </button>

            <button
              onClick={() => setActiveTab("student")}
              className={`rounded-full px-4 py-2 text-xs font-semibold transition ${
                activeTab === "student"
                  ? "bg-pink-600"
                  : "bg-white/10 hover:bg-white/20"
              }`}
            >
              🎓 Student Founder
            </button>

            <button
              onClick={() => setActiveTab("creator")}
              className={`rounded-full px-4 py-2 text-xs font-semibold transition ${
                activeTab === "creator"
                  ? "bg-pink-600"
                  : "bg-white/10 hover:bg-white/20"
              }`}
            >
              🎨 Creator Economy
            </button>

            <button
              onClick={() => setActiveTab("digital")}
              className={`rounded-full px-4 py-2 text-xs font-semibold transition ${
                activeTab === "digital"
                  ? "bg-pink-600"
                  : "bg-white/10 hover:bg-white/20"
              }`}
            >
              🌐 Digital Business
            </button>
          </div>

          <div className="mt-4 rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-6">
            {activeTab === "startup" && (
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-2">
                {[
                  "Problem Discovery",
                  "Business Model",
                  "Pitch Deck",
                  "Investor Connect",
                ].map((item) => (
                  <div
                    key={item}
                    className="rounded-2xl bg-white/5 border border-white/10 p-5"
                  >
                    <div className="text-3xl">🚀</div>
                    <h4 className="text-gray-100 mt-2 font-bold text-sm">{item}</h4>
                  </div>
                ))}
              </div>
            )}

            {activeTab === "student" && (
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-2">
                {[
                  "Campus Clubs",
                  "Hackathons",
                  "Innovation Challenges",
                  "Incubation",
                ].map((item) => (
                  <div
                    key={item}
                    className="rounded-2xl bg-white/5 border border-white/10 p-5"
                  >
                    <div className="text-3xl">🎓</div>

                    <h4 className="text-gray-100 mt-2 font-bold text-sm">{item}</h4>
                  </div>
                ))}
              </div>
            )}

            {activeTab === "creator" && (
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-2">
                {[
                  "Digital Products",
                  "Courses",
                  "Communities",
                  "Personal Brand",
                ].map((item) => (
                  <div
                    key={item}
                    className="rounded-2xl bg-white/5 border border-white/10 p-5"
                  >
                    <div className="text-3xl">🎨</div>

                    <h4 className="text-gray-100 mt-2 font-bold text-sm">{item}</h4>
                  </div>
                ))}
              </div>
            )}

            {activeTab === "digital" && (
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-2">
                {["Online Store", "AI Tools", "Marketing", "Automation"].map(
                  (item) => (
                    <div
                      key={item}
                      className="rounded-2xl bg-white/5 border border-white/10 p-5"
                    >
                      <div className="text-3xl">🌐</div>

                      <h4 className="text-gray-100 mt-2 font-bold text-sm">{item}</h4>
                    </div>
                  ),
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* WHY JOIN */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-2">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-5">
            {[
              {
                icon: "🤝",
                title: "Expert Mentors",
                desc: "Learn directly from experienced founders and professionals.",
              },
              {
                icon: "💰",
                title: "Funding Ready",
                desc: "Investor decks, financial modelling and pitch preparation.",
              },
              {
                icon: "🤖",
                title: "AI Co-Founder",
                desc: "Use AI for research, planning, validation and execution.",
              },
              {
                icon: "🌎",
                title: "Global Community",
                desc: "Network with founders, mentors and ecosystem partners.",
              },
            ].map((card) => (
              <div
                key={card.title}
                className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-6 hover:-translate-y-2 transition duration-300"
              >
                <div className="text-5xl">{card.icon}</div>

                <h3 className="text-cyan-200 mt-3 font-bold text-lg">{card.title}</h3>

                <p className="mt-2 text-xs leading-6 text-slate-200">
                  {card.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* ====================================================== */}
      {/* MENTOR ECOSYSTEM */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-2">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <span className="inline-flex rounded-full border border-violet-400/20 bg-violet-500/10 px-3 py-1 text-[11px] font-semibold text-violet-200">
              🤝 Mentorship Network
            </span>

            <h2 className="text-yellow-100 mt-2 text-2xl sm:text-4xl font-black">
              Learn From People Who Have Built Before
            </h2>

            <p className="mt-2 max-w-3xl mx-auto text-sm text-slate-200">
              Weekly office hours, founder circles, domain experts, investor
              feedback and peer accountability designed to accelerate execution.
            </p>
          </div>

          <div className="mt-5 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              {
                emoji: "🚀",
                title: "Startup Mentors",
                desc: "Business model, product-market fit and execution.",
              },
              {
                emoji: "💻",
                title: "Technology",
                desc: "AI, SaaS, product architecture and digital platforms.",
              },
              {
                emoji: "📢",
                title: "Marketing",
                desc: "Growth, branding, storytelling and customer acquisition.",
              },
              {
                emoji: "💰",
                title: "Investors",
                desc: "Pitch reviews, valuation and fundraising readiness.",
              },
            ].map((mentor) => (
              <div
                key={mentor.title}
                className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-5 hover:bg-white/10 transition duration-300"
              >
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-pink-600 to-violet-600 flex items-center justify-center text-3xl">
                  {mentor.emoji}
                </div>

                <h3 className="text-cyan-200 mt-3 font-bold">{mentor.title}</h3>

                <p className="mt-2 text-xs leading-6 text-slate-200">
                  {mentor.desc}
                </p>

                <button className="mt-3 rounded-xl bg-white/10 px-4 py-2 text-xs font-semibold hover:bg-white/20">
                  Meet Mentors →
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* PROGRAMS */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-2">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-3 gap-6">
            {[
              {
                icon: "⚡",
                title: "30 Day Sprint",
                color: "from-pink-600 to-rose-600",
                items: [
                  "Problem Validation",
                  "Customer Interviews",
                  "Idea Refinement",
                  "Business Canvas",
                ],
              },
              {
                icon: "🚀",
                title: "90 Day Accelerator",
                color: "from-violet-600 to-indigo-600",
                items: ["MVP Launch", "Go-To-Market", "Sales", "Growth"],
              },
              {
                icon: "🦄",
                title: "Scale Program",
                color: "from-cyan-600 to-blue-600",
                items: ["Fundraising", "Hiring", "Expansion", "Leadership"],
              },
            ].map((program) => (
              <div
                key={program.title}
                className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl overflow-hidden"
              >
                <div className={`bg-gradient-to-r ${program.color} p-6`}>
                  <div className="text-5xl">{program.icon}</div>

                  <h3 className="text-cyan-200 mt-2 text-xl font-black">{program.title}</h3>
                </div>

                <div className="p-6 space-y-3">
                  {program.items.map((item) => (
                    <div key={item} className="flex items-center gap-3 text-sm">
                      <span className="text-emerald-400">✔</span>

                      <span className="text-slate-100">{item}</span>
                    </div>
                  ))}

                  <button className="mt-2 w-full rounded-xl bg-white/10 py-3 text-sm font-semibold hover:bg-white/20">
                    Learn More
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* FUNDING ROADMAP */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-2">
        <div className="max-w-6xl mx-auto">
          <div className="text-center">
            <h2 className="text-yellow-100 text-2xl sm:text-4xl font-black">Funding Journey</h2>

            <p className="mt-2 text-sm text-slate-200">
              Prepare systematically before approaching investors.
            </p>
          </div>

          <div className="mt-5 grid md:grid-cols-5 gap-2">
            {[
              {
                icon: "💡",
                title: "Idea",
              },
              {
                icon: "📄",
                title: "Pitch",
              },
              {
                icon: "📊",
                title: "Validation",
              },
              {
                icon: "🤝",
                title: "Investor",
              },
              {
                icon: "💰",
                title: "Funding",
              },
            ].map((item) => (
              <div
                key={item.title}
                className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-5 text-center hover:bg-white/10 transition"
              >
                <div className="text-5xl">{item.icon}</div>

                <div className="mt-2 font-bold">{item.title}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* IMPACT */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-2">
        <div className="max-w-7xl mx-auto rounded-3xl border border-white/10 bg-gradient-to-r from-pink-600/10 via-violet-600/10 to-cyan-600/10 backdrop-blur-xl p-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              ["250K+", "Young Women"],
              ["50K+", "Startups"],
              ["5K+", "Mentors"],
              ["100Cr+", "Funding Vision"],
            ].map((item) => (
              <div key={item[1]} className="text-center">
                <div className="text-3xl sm:text-4xl font-black text-pink-300">
                  {item[0]}
                </div>

                <div className="mt-2 text-sm text-slate-100">{item[1]}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* TESTIMONIALS */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-2">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-yellow-100 text-center text-2xl sm:text-4xl font-black">
            Founder Stories
          </h2>

          <div className="mt-5 grid lg:grid-cols-3 gap-5">
            {[
              {
                emoji: "👩🏻‍💼",
                name: "Student Founder",
                quote:
                  "FoundHer helped me transform a college idea into a real startup.",
              },
              {
                emoji: "👩🏽‍💻",
                name: "Tech Entrepreneur",
                quote:
                  "The mentors challenged every assumption and accelerated our growth.",
              },
              {
                emoji: "👩🏼‍🚀",
                name: "Creator Founder",
                quote:
                  "The structured roadmap kept me accountable every single week.",
              },
            ].map((story) => (
              <div
                key={story.name}
                className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-6"
              >
                <div className="text-5xl">{story.emoji}</div>

                <p className="mt-3 text-sm italic text-slate-100 leading-7">
                  "{story.quote}"
                </p>

                <div className="mt-3 font-bold">{story.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* ====================================================== */}
      {/* MEMBERSHIP PLANS */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-2">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <span className="inline-flex rounded-full border border-pink-400/20 bg-pink-500/10 px-3 py-1 text-[11px] font-semibold text-pink-200">
              💎 Join FoundHer
            </span>

            <h2 className="text-yellow-100 mt-2 text-2xl sm:text-4xl font-black">
              Choose Your Founder Journey
            </h2>

            <p className="mt-2 max-w-2xl mx-auto text-sm text-slate-200">
              Start free, learn consistently and upgrade whenever you're ready
              to accelerate.
            </p>
          </div>

          <div className="mt-5 grid lg:grid-cols-3 gap-6">
            {[
              {
                badge: "🌱",
                title: "Explorer",
                price: "FREE",
                featured: false,
                features: [
                  "Community Access",
                  "Learning Resources",
                  "Startup News",
                  "Monthly Webinar",
                ],
              },
              {
                badge: "🚀",
                title: "Accelerator",
                price: "₹499",
                featured: true,
                features: [
                  "Everything in Explorer",
                  "Mentor Sessions",
                  "AI Startup Assistant",
                  "Pitch Review",
                  "Founder Network",
                ],
              },
              {
                badge: "🦄",
                title: "Elite Founder",
                price: "₹1499",
                featured: false,
                features: [
                  "Everything in Accelerator",
                  "Investor Connect",
                  "Priority Mentorship",
                  "Leadership Circle",
                  "Growth Strategy",
                ],
              },
            ].map((plan) => (
              <div
                key={plan.title}
                className={`rounded-3xl border backdrop-blur-xl overflow-hidden transition hover:-translate-y-2 ${
                  plan.featured
                    ? "border-pink-500 bg-pink-500/10"
                    : "border-white/10 bg-white/5"
                }`}
              >
                <div className="p-6">
                  <div className="text-5xl">{plan.badge}</div>

                  <h3 className="text-cyan-200 mt-3 text-2xl font-black">{plan.title}</h3>

                  <div className="mt-2 text-4xl font-black text-pink-300">
                    {plan.price}
                  </div>

                  <div className="mt-3 space-y-3">
                    {plan.features.map((item) => (
                      <div
                        key={item}
                        className="flex items-center gap-3 text-sm"
                      >
                        <span className="text-emerald-400">✔</span>
                        <span className="text-slate-100">{item}</span>
                      </div>
                    ))}
                  </div>

                  <button className="mt-4 w-full rounded-xl bg-gradient-to-r from-pink-600 to-violet-600 py-3 text-sm font-bold hover:scale-[1.02] transition">
                    Join Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* STARTUP TOOLKIT */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-2">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-5">
            {[
              {
                icon: "📄",
                title: "Pitch Deck",
                desc: "Professional investor-ready templates.",
              },
              {
                icon: "📊",
                title: "Business Canvas",
                desc: "Design and validate your startup model.",
              },
              {
                icon: "🤖",
                title: "AI Assistant",
                desc: "Generate plans, research and strategies.",
              },
              {
                icon: "📅",
                title: "Execution Planner",
                desc: "Track weekly startup milestones.",
              },
            ].map((tool) => (
              <div
                key={tool.title}
                className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-6 hover:bg-white/10 transition"
              >
                <div className="text-5xl">{tool.icon}</div>

                <h3 className="text-cyan-200 mt-3 font-bold">{tool.title}</h3>

                <p className="mt-2 text-xs leading-6 text-slate-200">
                  {tool.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* RESOURCE LIBRARY */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-2">
        <div className="max-w-6xl mx-auto">
          <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-8">
            <h2 className="text-yellow-100 text-2xl sm:text-3xl font-black text-center">
              📚 Startup Resource Library
            </h2>

            <div className="mt-4 grid md:grid-cols-2 gap-2">
              {[
                "Startup Checklists",
                "Funding Guides",
                "Marketing Playbooks",
                "Legal Basics",
                "Founder Mindset",
                "Growth Templates",
                "AI Prompts",
                "Investor Pitch Samples",
              ].map((item) => (
                <div
                  key={item}
                  className="rounded-xl bg-white/5 border border-white/10 p-2 text-sm hover:bg-white/10 transition"
                >
                  📘 {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* FAQ */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-2">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-yellow-100 text-center text-2xl sm:text-4xl font-black">
            Frequently Asked Questions
          </h2>

          <div className="mt-5 space-y-4">
            {[
              [
                "Who can join?",
                "Students, aspiring entrepreneurs, creators and young women interested in building startups.",
              ],
              [
                "Do I need a business idea?",
                "No. You can join with only curiosity and an ambition to build.",
              ],
              [
                "Will mentors be available?",
                "Yes. Mentors, experts and founder communities support every stage.",
              ],
              [
                "Is funding guaranteed?",
                "No. The program prepares founders to become investment-ready.",
              ],
            ].map((faq) => (
              <details
                key={faq[0]}
                className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl p-5"
              >
                <summary className="cursor-pointer font-bold text-sm">
                  {faq[0]}
                </summary>

                <p className="mt-2 text-sm leading-7 text-slate-200">
                  {faq[1]}
                </p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* FINAL CTA */}
      {/* ====================================================== */}

      <section className="relative z-10 px-4 py-20">
        <div className="max-w-5xl mx-auto rounded-[32px] border border-pink-500/20 bg-gradient-to-r from-pink-600/15 via-violet-600/15 to-cyan-600/15 backdrop-blur-xl p-10 text-center">
          <div className="text-6xl">🚀</div>

          <h2 className="text-yellow-100 mt-3 text-3xl sm:text-5xl font-black leading-tight">
            Your Startup Journey
            <br />
            Starts Today
          </h2>

          <p className="mt-3 max-w-2xl mx-auto text-sm sm:text-base leading-7 text-slate-100">
            Build meaningful startups, create employment, solve real problems
            and become part of India's next generation of women founders.
          </p>

          <div className="mt-5 flex flex-wrap justify-center gap-2">
            <button className="rounded-xl bg-gradient-to-r from-pink-600 to-violet-600 px-6 py-3 text-sm font-bold hover:scale-105 transition">
              🚀 Join FoundHer
            </button>

            <button className="rounded-xl border border-white/20 bg-white/10 px-6 py-3 text-sm font-semibold hover:bg-white/20 transition">
              📖 Learn More
            </button>
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/* FOOTER */}
      {/* ====================================================== */}

      <footer className="relative z-10 border-t border-white/10 bg-black/20 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col md:flex-row items-center justify-between gap-2">
          <div>
            <div className="text-xl font-black">🚀 Think5Whys Youth Job & Women Empoerment Mission</div>

            <div className="mt-2 text-xs text-slate-200">
              Youth Founder Acceleration • Build • Launch • Scale
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-2 text-xs text-slate-200">
            <button className="hover:text-white transition">About</button>
            <button className="hover:text-white transition">Programs</button>
            <button className="hover:text-white transition">Mentors</button>
            <button className="hover:text-white transition">Contact</button>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default YouthFounderAcceleration;
